import React from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import { getStreamClient } from '@/services/stream/client';

export function ProfileSection() {
  const client = getStreamClient();
  const user = client.user;
  const avatarUri = user?.image || 'https://getstream.io/random_png/?name=' + (user?.name || 'User');

  return (
    <View style={styles.container}>
      <Image source={{ uri: avatarUri }} style={styles.avatar} />
      <Text style={styles.userName}>{user?.name || 'User'}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: 40,
  },
  avatar: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 15,
    backgroundColor: '#F0F0F0',
  },
  userName: {
    fontSize: 20,
    fontWeight: '700',
    color: '#333',
  },
});
